



































import { Component, Prop, Vue } from "vue-property-decorator";
import { ProfessionalSummaryDetailsModel } from "@/types/aznconnect_api";
import InformationCard from "@/components/InformationCard.vue";

@Component({
  components: {
    "information-card": InformationCard,
  },
})
export default class RawMessageView extends Vue {
  @Prop({ default: null })
  psModel!: ProfessionalSummaryDetailsModel;

  copyRawMessageToClipboard(): void {
    var textArea = $("#rawMessageTextarea");
    textArea.removeAttr("disabled");
    textArea.select();
    try {
      var successful = document.execCommand("copy");
      textArea.select();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }

    var selection = document.getSelection();
    if (selection != null) {
      selection.removeAllRanges();
    }

    textArea.attr("disabled", "disabled");
  }

  downloadRawMessageToClipboard(): void {
    var me = this;

    me.forceFileDownload("professionele-samenvatting", me.psModel.RawMessage);
  }

  forceFileDownload(fileName: string, data: any) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName + ".xml");
    document.body.appendChild(link);
    link.click();
  }
}
